export default __webpack_public_path__ + "static/media/phonepe.bf97fe07.svg";